import React from "react";

export default function Header() {
  return <div className="header">Chat with Vincent Chu AI</div>;
}
